import React from "react";
import { useState } from "react";
import { Switch } from "antd";
import CommonTable from "../../common/table/index.js";

import APIService from "../../Service/APIService";
import Swal from "sweetalert2";
import SectionHeader from "../../common/section-header/index.js";
// import { tableHeadersAccountProductPricing } from "../Utils/Constants.js";
import StatusIndicator from "../../common/status-indicator/index.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import ModalView from "../../common/modal/index.js";
import TextInput from "../../common/text-input/index.js";
import CommonButton from "../../common/button/button.js";
import Text from "../../common/typography/text.js";
import Tags from "../../common/tags/index.js";
import RowIcon from "../../common/row-icon/index.js";
import QuickList from "../../common/list-component/quick-list.js";
import RequiredIcon from "../../icons/required-icon.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import { isValidDiscount } from "../AccountEnrollment/accountEnrollmentPricing.js";
import "./ProductPricing.css";


const ProductPricing = (props) => {
  const { accountData } = props;
  const readOnly = props.readOnly === true;
  const { user } = useAuth();
  const userData = user;
  const [productsData] = React.useState([]);
  const [productsGroupData, setProductsGroupData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [productCatalogError, setProductCatalogError] = React.useState("");
  const [productsUnderProductGroup, setProductsUnderProductGroup] = useState(
    []
  );
  const [viewModalRowData, setViewModalRowData] = useState();

  const [showViewModal, setShowViewModal] = useState(false);
  const [manufacturerName, setManufacturerName] = useState("");
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [price, setPrice] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [productID] = useState("");
  const [accountProductID] = useState("");

  // product group
  const [showProductGroupView, setShowProductGroupView] = useState(false);
  const [showProductGroupEdit, setShowProductGroupEdit] = useState(false);
  // products group form
  const [productGroupNameEdit, setProductGroupNameEdit] = useState(null);
  const [productGroupRateEdit, setProductGroupRateEdit] = useState(null);
  const [productGroupQCodeEdit, setProductGroupQCodeEdit] = useState(null);
  const [productGroupDiscountEdit, setProductGroupDiscountEdit] =
    useState(null);
  const [productGroupCustomPricingEdit, setProductGroupCustomPricingEdit] =
    useState(false);
  const [productGroupDefaultDiscount, setProductGroupDefaultDiscount] =
    useState(0);
  const [lastDiscountEdit, setLastDiscountEdit] = useState(null);
  const [productGroupEditError, setProductGroupEditError] = useState("");
  const [productGroupSubmitting, setProductGroupSubmitting] = useState(false);

  // const getProductsData = async (accountID, manufacturerID) => {
  //   if (accountID && manufacturerID) {
  //     const apiServe = new APIService();
  //     const response = await apiServe.getDataFromBackend(
  //       `getproductsfromaccountid?Type=Accounts&AccountID=${accountID}&ManufacturerID=${manufacturerID}`
  //     );
  //     // setProductsData(...productsData, response?.data?.data);
  //     return response?.data?.data;
  //   }
  // };

  const handleTableSubmit = async () => {
    if (readOnly) return;
    console.log("Products Data: ", productsData);

    const updatedProductsData = [
      {
        ID: accountProductID,
        ProductID: productID,
        Price: price,
        IsEnabled: isEnabled,
      },
    ];

    console.log(updatedProductsData, "product >>> 1");
    console.log("Products Data: 1", updatedProductsData);
    // addproducttoaccount
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend(
          updatedProductsData,
          "updateproducttoaccount"
        );
        console.log("Product Submit Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire({
            title: "Success!",
            text: "Product data saved successfully.",
            icon: "success",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Error in saving product data.",
            icon: "error",
          });
        }
      }
    });
  };
  // const [manufacturers, setManufacturers] = React.useState([]);

  // const getManufacturersFromAccount = async () => {
  //   const apiServe = new APIService();
  //   if (accountData && accountData?.ID) {
  //     const response = await apiServe.getDataFromBackend(
  //       `getmanufacturersfromaccount?ID=${accountData.ID}`
  //     );

  //     // setManufacturers(response?.data?.data);
  //     const manufacturers = response?.data?.data;
  //     let tempProducts = [];
  //     for (let i = 0; i < manufacturers.length; i++) {
  //       const tempProds = await getProductsData(
  //         accountData.ID,
  //         manufacturers[i].ID
  //       );
  //       tempProds.map((ele) => {
  //         ele["ManufacturerName"] = manufacturers[i].ManufacturerName;
  //         tempProducts.push(ele);
  //       });
  //       // tempProducts.push(...tempProds);
  //     }
  //     console.log("Temp Products: ", tempProducts);

  //     return tempProducts;
  //   }
  //   // return [];
  // };

  const getProductGroupsByAccountID = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `GetProductGroupsByAccountID?AccountID=${accountData.ID}`
    );

    console.log(response?.data?.data, "response >>> 1");
    return response?.data?.data;
  };

  React.useEffect(() => {
    // let tempProducts = [];
    // getManufacturersFromAccount().then((prodsData) => {
    //   setProductsData(prodsData);

    //   setColumns(generateSchema(prodsData));
    // });

    getProductGroupsByAccountID()
      .then((prodGroupData) => {
        setProductsGroupData(prodGroupData || []);
      })
      .catch((error) => {
        setProductCatalogError(
          error?.response?.data?.error || "Unable to load account product pricing.",
        );
      })
      .finally(() => setLoading(false));
  }, []);

  const handleShowViewModal = () => {
    setShowViewModal(true);
  };

  const getTableHeadersAccountProductPricing = (handleShowViewModal) =>
    userData.Type === "Admin"
      ? [
          {
            headerName: "Manufacturer",
            field: "ManufacturerName",
            filter: true,
            // flex: 1,
            // cellRenderer: (params) => (
            //   <TableLink
            //     value={params.data.ManufacturerName}
            //     path={`/Manufacturer/${params.data.ManufacturerID}`}
            //   />
            // ),
          },
          {
            headerName: "Product Name",
            field: "ProductName",
            filter: true,
            // flex: 1,
          },
          {
            headerName: "Product Code",
            field: "ProductCode",
            filter: true,
          },
          {
            headerName: "Price for this Account",
            field: "Price",
            filter: true,
            // flex: 1,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Price).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Price).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Availability",
            field: "",
            // flex: 1,
            cellRenderer: (params) => <StatusIndicator params={params} />,
          },
          {
            headerName: "Action",
            field: "",
            cellRenderer: () => (
              <TableOptionsCell
                optionOne="View"
                optionOneType="warning"
                optionOneClickFn={() => handleShowViewModal()}
              />
            ),
          },
        ]
      : [
          {
            headerName: "Manufacturer",
            field: "ManufacturerName",
            filter: true,
            // flex: 1,
            // cellRenderer: (params) => (
            //   <TableLink
            //     value={params.data.ManufacturerName}
            //     path={`/Manufacturer/${params.data.ManufacturerID}`}
            //   />
            // ),
          },
          {
            headerName: "Product Name",
            field: "ProductName",
            filter: true,
            // flex: 1,
          },
          {
            headerName: "Product Code",
            field: "ProductCode",
            filter: true,
          },
          {
            headerName: "Price for this Account",
            field: "Price",
            filter: true,
            // flex: 1,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Price).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Price).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Availability",
            field: "",
            // flex: 1,
            cellRenderer: (params) => <StatusIndicator params={params} />,
          },
        ];

  const handleChangeEdit = (index, field, value) => {
    if (readOnly) return;
    const newProducts = [...productsUnderProductGroup];
    newProducts[index][field] = value;
    console.log(newProducts, "new products >>>>> 1");
    setProductsUnderProductGroup(newProducts);
  };

  const handleEditAccountProductGroupModal = (row) => {
    if (readOnly) return;
    console.log(row, "row edit >>>> 1");
    setShowProductGroupEdit(true);
    setProductGroupNameEdit(row?.ProductGroupName);
    setProductGroupCustomPricingEdit(Boolean(row?.CustomPricing));
    setProductGroupDefaultDiscount(row?.DefaultAccountDiscount ?? 0);
    setProductGroupDiscountEdit(
      row?.CustomPricing ? 0 : row?.DiscountPercentage ?? row?.DefaultAccountDiscount ?? 0,
    );
    setLastDiscountEdit(row?.DiscountPercentage ?? row?.DefaultAccountDiscount ?? 0);
    setProductGroupRateEdit(row?.Rate);
    setProductGroupQCodeEdit(row?.QCode);
    setProductsUnderProductGroup(row?.Products);
    setViewModalRowData(row);
    setProductGroupEditError("");
  };

  const handleProductGroupPricingMode = (applyDiscount) => {
    if (applyDiscount) {
      setProductGroupCustomPricingEdit(false);
      setProductGroupDiscountEdit(
        lastDiscountEdit ?? productGroupDefaultDiscount ?? 0,
      );
      return;
    }

    setLastDiscountEdit(productGroupDiscountEdit);
    setProductGroupCustomPricingEdit(true);
    setProductGroupDiscountEdit(0);
    setProductsUnderProductGroup((products) =>
      products.map((product) => ({
        ...product,
        Price: Number(product.StandardPrice).toFixed(2),
      })),
    );
  };

  const handleViewAccountProductGroupModal = (row) => {
    setShowProductGroupView(true);
    setViewModalRowData(row);
    setProductsUnderProductGroup(row?.Products);
  };

  const getTableHeadersAccountProductGroup = (
    handleEditAccountProductGroupModal,
    handleViewAccountProductGroupModal
  ) =>
    userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.edit")
      ? [
          {
            headerName: "Manufacturer Name",
            field: "ManufacturerName",
            filter: true,
          },
          {
            headerName: "Product Group Name",
            field: "ProductGroupName",
            filter: true,
            cellRenderer: (params) => {
              return (
                <CommonButton
                  variant="link"
                  onClick={() =>
                    handleViewAccountProductGroupModal(params.data)
                  }
                >
                  {params.data.ProductGroupName}
                </CommonButton>
              );
            },
          },
          {
            headerName: "HCPCS Code",
            field: "QCode",
            filter: true,
          },
          {
            headerName: "Rate",
            field: "Rate",
            filter: true,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Rate).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Rate).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Discount",
            field: "DiscountPercentage",
            filter: true,
            cellRenderer: (params) => {
              return params?.data?.CustomPricing
                ? "Custom Price"
                : `${params?.data?.DiscountPercentage ?? 0}%`;
            },
          },
          {
            headerName: "Requires IVR",
            field: "IVR",
            filter: true,
            cellRenderer: (params) => (
              <Tags
                textColor={
                  params.data.IVR ? "successColorDark" : "failureColorDark"
                }
                tagBackground={
                  params.data.IVR ? "successColorLight" : "failureColorLight"
                }
                tagText={params.data.IVR ? "Yes" : "No"}
              />
            ),
          },
          {
            headerName: "Action",
            field: "",
            cellRenderer: (params) =>
              userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.edit") && !readOnly ? (
                <>
                  <TableOptionsCell
                    optionOne="Edit"
                    optionOneType="warning"
                    optionOneClickFn={() =>
                      handleEditAccountProductGroupModal(params.data)
                    }
                    rowData={params.data}
                  />
                </>
              ) : null,
          },
        ]
      : [
          {
            headerName: "Manufacturer Name",
            field: "ManufacturerName",
            filter: true,
          },
          {
            headerName: "Product Group Name",
            field: "ProductGroupName",
            filter: true,
            cellRenderer: (params) => {
              return (
                <CommonButton
                  variant="link"
                  onClick={() =>
                    handleViewAccountProductGroupModal(params.data)
                  }
                >
                  {params.data.ProductGroupName}
                </CommonButton>
              );
            },
          },
          {
            headerName: "HCPCS Code",
            field: "QCode",
            filter: true,
          },
          {
            headerName: "Rate",
            field: "Rate",
            filter: true,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Rate).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Rate).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Discount",
            field: "DiscountPercentage",
            filter: true,
            cellRenderer: (params) => {
              return params?.data?.CustomPricing
                ? "Custom Price"
                : `${params?.data?.DiscountPercentage ?? 0}%`;
            },
          },
          {
            headerName: "Requires IVR",
            field: "IVR",
            filter: true,
            cellRenderer: (params) => (
              <Tags
                textColor={
                  params.data.IVR ? "successColorDark" : "failureColorDark"
                }
                tagBackground={
                  params.data.IVR ? "successColorLight" : "failureColorLight"
                }
                tagText={params.data.IVR ? "Yes" : "No"}
              />
            ),
          },
        ];

  const tableHeadersAccountProductGroup = getTableHeadersAccountProductGroup(
    handleEditAccountProductGroupModal,
    handleViewAccountProductGroupModal
  );

  const handleAvailableToggle = () => {
    if (readOnly) return;
    setIsEnabled(!isEnabled);
  };

  const handleProductStatus = () => {
    if (readOnly) return;
    const newPrds = productsUnderProductGroup?.map((prd) => ({
      ...prd,
      IsEnabled: false,
    }));
    console.log(newPrds, "newPrds>>>> 1");
    setProductsUnderProductGroup(newPrds);
  };

  const handleToggleEnableStatus = (prd, ind) => {
    if (readOnly) return;
    // const newPrds = productsUnderProductGroup?.map((prd) => ({
    //   ...prd,
    //   IsEnabled: !prd.IsEnabled,
    // }));
    // console.log(newPrds, "newPrds>>>> 2");
    // console.log({ prd, ind }, "newPrds>>>> 3");
    // setProductsUnderProductGroup(newPrds);
    const newPrds = productsUnderProductGroup.map((item, i) =>
      i === ind ? { ...item, IsEnabled: !item.IsEnabled } : item
    );
    setProductsUnderProductGroup(newPrds);
  };

  const submitEditProductGroupHandler = async () => {
    if (readOnly || productGroupSubmitting) return;
    setProductGroupEditError("");
    const validDiscount = isValidDiscount(productGroupDiscountEdit);
    if (!productGroupCustomPricingEdit && !validDiscount) {
      setProductGroupEditError("Enter a discount from 0 to 100 with at most two decimals.");
      return;
    }
    if (
      productGroupCustomPricingEdit &&
      productsUnderProductGroup.some(
        (product) =>
          !Number.isFinite(Number(product.Price)) ||
          Number(Number(product.Price).toFixed(2)) <= 0,
      )
    ) {
      setProductGroupEditError("Every custom price must be greater than 0.");
      return;
    }
    const finalProducts = productsUnderProductGroup.map((product) => ({
      ...product,
      Price: productGroupCustomPricingEdit
        ? Number(Number(product.Price).toFixed(2))
        : Number(
            (
              parseFloat(product?.StandardPrice) -
              (Number(productGroupDiscountEdit) * parseFloat(product?.StandardPrice)) / 100
            ).toFixed(2),
          ),
    }));

    const editProductGroupObj = {
      ProductGroup: {
        ID: viewModalRowData?.ID,
        AccountID: accountData?.ID,
        ProductGroupName: viewModalRowData?.ProductGroupName,
        Rate: viewModalRowData?.Rate,
        QCode: viewModalRowData?.QCode,
        ManufacturerID: viewModalRowData?.ManufacturerID,
        CustomPricing: productGroupCustomPricingEdit,
        DiscountPercentage: productGroupCustomPricingEdit
          ? null
          : Number(productGroupDiscountEdit),
        Version: viewModalRowData?.Version,
      },
      Products: finalProducts,
    };
    console.log(editProductGroupObj, "editProductGroupObj >>>> 1");
    const apiServe = new APIService();
    Swal.fire({
      title: "Are you sure?",
      text: "You want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setProductGroupSubmitting(true);
        console.log("Post Object:", editProductGroupObj);
        try {
          const response = await apiServe.addDataToBackend(
            editProductGroupObj,
            "EditAccountProductGroup"
          );
          console.log("Saved Product Group Response: ", response);
          Swal.fire(
            "Saved Changes!",
            "Product Group has been edited.",
            "success"
          ).then(() => window.location.reload());
        } catch (error) {
          setProductGroupEditError(
            error?.response?.data?.error || "An error occurred while saving pricing.",
          );
        } finally {
          setProductGroupSubmitting(false);
        }
      }
    });
  };

  console.log({ productsGroupData }, "productsData >>>> 2");
  console.log({ viewModalRowData }, "PRODUCTS >>>>> 1");
  console.log({ productsUnderProductGroup }, "productsUnderProductGroup");

  return (
    <div>
      {accountData && productsData && (
        <div>
          <SectionHeader title="Product Catalog" showButton={false} />
          {productCatalogError && (
            <Text variant="smallText" color="failureColor">
              {productCatalogError}
            </Text>
          )}
          <CommonTable
            rowData={productsGroupData}
            columnDefs={tableHeadersAccountProductGroup}
            screen="AccountProductCatalog"
            loading={loading}
          />
        </div>
      )}
      <ModalView
        isOpen={showViewModal && !readOnly}
        onClose={() => setShowViewModal(false)}
        modalTitle="Edit Product Details"
        modalSubTitle="Changes made here will reflect on for account."
        textInputComponent={
          <div className="field-group-wrapper">
            <div className="field-group">
              <TextInput
                titleText="Manufacturer Name"
                placeholder="Manufacturer Name"
                value={manufacturerName}
                isDisabled
                setValue={(text) => setManufacturerName(text)}
              />
            </div>
            <div className="field-group">
              <TextInput
                titleText="Product Name"
                placeholder="Product Name"
                isDisabled
                value={productName}
                setValue={(name) => setProductName(name)}
              />
              <TextInput
                titleText="Product Code"
                placeholder="Product Code"
                isDisabled
                value={productCode}
                setValue={(code) => setProductCode(code)}
              />
            </div>
            <div className="field-group">
              <TextInput
                titleText="Set Price for this Account"
                placeholder="000.00"
                value={price}
                setValue={(price) => {
                  setPrice(price);
                }}
              />
            </div>
          </div>
        }
        footerButtonWrapper={
          <div className="footer-button-wrapper">
            {userData?.Type === "Admin" && (
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => handleTableSubmit(productCode)}
              >
                Save
              </CommonButton>
            )}
            <CommonButton
              variant="table"
              subVariant={isEnabled ? "failure" : "success"}
              onClick={handleAvailableToggle}
            >
              Make {isEnabled ? "Unavailable" : "Available"}
            </CommonButton>
          </div>
        }
      />
      {/* Product groups modal  */}
      <ModalView
        isOpen={showProductGroupEdit && !readOnly}
        onClose={() => setShowProductGroupEdit(false)}
        modalTitle={`Edit Product Group for ${accountData?.AccountName}`}
        isLoading={productGroupSubmitting}
        textInputComponent={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Product Group Name"
                  placeholder="Product Group Name"
                  value={productGroupNameEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupNameEdit}
                />
                <TextInput
                  titleText="Rate"
                  placeholder="Rate"
                  value={productGroupRateEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupRateEdit}
                />
                <TextInput
                  titleText="HCPCS Code"
                  placeholder="HCPCS Code"
                  value={productGroupQCodeEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupQCodeEdit}
                />
                <div className="account-group-pricing-switch">
                  <Text variant="tinyText">Apply Discount</Text>
                  <Switch
                    checked={!productGroupCustomPricingEdit}
                    checkedChildren="✓"
                    unCheckedChildren="×"
                    aria-label={`Apply discount to ${productGroupNameEdit}`}
                    onChange={handleProductGroupPricingMode}
                  />
                </div>
                <TextInput
                  titleText="Discount"
                  placeholder="Discount"
                  value={productGroupCustomPricingEdit ? 0 : productGroupDiscountEdit}
                  type="number"
                  minValue={0}
                  maxValue={100}
                  step="0.01"
                  inputMode="decimal"
                  isRequired
                  isDisabled={productGroupCustomPricingEdit}
                  errorText={
                    !productGroupCustomPricingEdit && !isValidDiscount(productGroupDiscountEdit)
                      ? "Enter a discount from 0 to 100 with at most two decimals."
                      : ""
                  }
                  setValue={(value) => {
                    setProductGroupDiscountEdit(value);
                    setLastDiscountEdit(value);
                  }}
                />
              </div>
            </div>

            {/* {isLoadingProducts ? (
              <Text variant="bodyText">Loading products...</Text>
            ) : productsUnderGroup?.length === 0 ? (
              <Text variant="bodyText">
                No products have been added to this product group yet.{" "}
              </Text>
            ) : null} */}
            {productsUnderProductGroup?.map((product, index) => {
              return (
                <div className="field-group-wrapper" key={product.ProductID}>
                  <div className="field-group-end">
                    <TextInput
                      titleText="Product Name"
                      placeholder="Product Name"
                      value={product?.ProductName}
                      isRequired
                      isDisabled
                      // setValue={setProductNameEdit}
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductName", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Product Code"
                      placeholder="Product Code"
                      value={product?.ProductCode}
                      isRequired
                      isDisabled
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductCode", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Units"
                      placeholder="Units"
                      value={product?.Units}
                      isRequired
                      parentClassName="small-width-button"
                      onChange={(e) => {
                        handleChangeEdit(index, "Units", e.target.value);
                      }}
                    />
                    <TextInput
                      titleText="Standard Price"
                      placeholder="Standard Price"
                      value={product?.StandardPrice}
                      isRequired
                      isDisabled
                    />
                    <TextInput
                      titleText={productGroupCustomPricingEdit ? "Custom Price" : "Discounted Price"}
                      placeholder={productGroupCustomPricingEdit ? "0.00" : "{StandardPrice - Discount%}"}
                      value={
                        productGroupCustomPricingEdit
                          ? product?.Price
                          : product?.StandardPrice
                          ? (
                              product.StandardPrice -
                              (productGroupDiscountEdit *
                                product.StandardPrice) /
                                100
                            ).toFixed(2)
                          : ""
                      }
                      isRequired
                      isDisabled={!productGroupCustomPricingEdit}
                      type="number"
                      minValue={0.01}
                      step="0.01"
                      inputMode="decimal"
                      errorText={
                        productGroupCustomPricingEdit &&
                        (!Number.isFinite(Number(product?.Price)) ||
                          Number(Number(product?.Price).toFixed(2)) <= 0)
                          ? "Enter a price greater than 0."
                          : ""
                      }
                      setValue={(value) => handleChangeEdit(index, "Price", value)}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "16px",
                      }}
                      className="text-input-container small-width-button"
                    >
                      <div className="text-input-title">
                        <Text variant="tinyText">Availability</Text>
                        <RequiredIcon />
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleToggleEnableStatus(product, index)}
                      >
                        {product?.IsEnabled ? (
                          <RowIcon type="enabled" />
                        ) : (
                          <RowIcon />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {productGroupEditError && (
              <Text variant="smallText" color="failureColor">
                {productGroupEditError}
              </Text>
            )}
          </div>
        }
        footerButtonWrapper={
          <div className="footer-button-wrapper">
            <CommonButton
              variant="table"
              subVariant="success"
              onClick={submitEditProductGroupHandler}
              disabled={productGroupSubmitting}
            >
              {productGroupSubmitting ? "Saving…" : "Save"}
            </CommonButton>
            <CommonButton
              variant="table"
              subVariant="failure"
              onClick={handleProductStatus}
            >
              Make All Unavailable
            </CommonButton>
          </div>
        }
      />
      <ModalView
        isOpen={showProductGroupView}
        onClose={() => setShowProductGroupView(false)}
        modalTitle={`${viewModalRowData?.ProductGroupName} for ${accountData?.AccountName}`}
        textInputComponent={
          <>
            {productsUnderProductGroup?.length === 0 ? (
              <Text variant="bodyText">
                No products have been added to this product group yet.
              </Text>
            ) : (
              <div style={{ maxHeight: "400px" }}>
                <QuickList
                  items={productsUnderProductGroup}
                  primaryTitle="ProductName"
                  secondaryTitle="ProductCode"
                  price="Price"
                  tagKey="IsEnabled"
                  page="Accounts"
                  priceHeader="Units"
                  priceHeaderValue="Units"
                />
              </div>
            )}
          </>
        }
      />
    </div>
  );
};

export default ProductPricing;
